import { render, staticRenderFns } from "./DialogElement.vue?vue&type=template&id=954dee58&scoped=true&"
import script from "./DialogElement.vue?vue&type=script&lang=js&"
export * from "./DialogElement.vue?vue&type=script&lang=js&"
import style0 from "./DialogElement.vue?vue&type=style&index=0&id=954dee58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954dee58",
  null
  
)

export default component.exports